import { UserType } from 'generated/graphql'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import { getWebviewHref } from '@app.modules/util'
import { ChannelUserType } from 'app.constants/enums'
import { UserCardItem } from '../component/modals/NewsReactionModal/NewsReactionCard'

const defaultImage = {
  channel: '/static/images/channel/enterprise.png',
  user: '/static/images/channel/user-profile.png',
}

const useNewsReactionData = (data, currentTab) => {
  const isWebview = useIsWebview()

  const getUserType = (user) => {
    if (user?.__typename === 'Channel') {
      return ChannelUserType.CHANNEL
    } else {
      return user?.type === UserType.NORMAL
        ? ChannelUserType.NORMAL
        : ChannelUserType.OWNER
    }
  }

  const getUserName = (user, type) => {
    if (type === ChannelUserType.CHANNEL) return user.name
    if (type === ChannelUserType.OWNER) return user?.organization.name

    return user.username
  }

  const getImageUrl = (user, type) => {
    if (type === ChannelUserType.CHANNEL)
      return user.owner.logoImage?.url || defaultImage.channel
    if (type === ChannelUserType.NORMAL)
      return user.avatarUrl || defaultImage.user

    return defaultImage.user
  }

  const getChannelUrl = (user, type) => {
    if (type === ChannelUserType.CHANNEL)
      return getWebviewHref(`/channel/${user.url}`, isWebview)

    return ''
  }

  const nodes =
    currentTab === 'scrap' ? data?.bookmarkers?.nodes : data?.likers?.nodes

  const dataSet: UserCardItem[] = nodes?.map((user) => {
    const userType = getUserType(user)
    const newsItems =
      currentTab === 'scrap'
        ? user?.bookmarks?.nodes || []
        : user?.likes?.nodes || []

    return {
      id: user?.id,
      type: userType,
      name: getUserName(user, userType),
      description:
        userType === ChannelUserType.CHANNEL ? user.briefDescription : '',
      channelUrl: getChannelUrl(user, userType),
      imageUrl: getImageUrl(user, userType),
      viewerIsOwner: user?.viewerIsOwner || false,
      viewerHasFollowed: user?.viewerHasFollowed || false,
      currentTab,
      newsItem:
        newsItems.slice(0, 2).map((newsItem) => {
          return {
            id: newsItem.id,
            content: newsItem.content.replace(/<[^>]*>?/g, ''),
            newsItemUrl: getWebviewHref(
              `/channel/${newsItem.channel?.url}/${newsItem.id}`,
              isWebview,
            ),
          }
        }) || [],
    }
  })

  return { dataSet }
}

export default useNewsReactionData
